import React, { ComponentProps, useContext } from 'react';

import { Sidebar } from '../../sidebar';
import { FullLayoutNavStateContext, useFullLayoutContext } from '../context';
import { FullLayoutLeftSidebar } from '../left-sidebar-pane';

export function LeftSidebar(props: ComponentProps<typeof Sidebar>) {
  const ctx = useFullLayoutContext();
  const navState = useContext(FullLayoutNavStateContext);
  if (!ctx) return null;
  if (ctx.disableLeftSideNav) return null;

  const sidebarProps: ComponentProps<typeof Sidebar> =
    navState != null
      ? {
          ...props,
          appNavActiveId: navState.appNavActiveId ?? props.appNavActiveId,
          sectionNavActiveId: navState.sectionNavActiveId ?? props.sectionNavActiveId,
          activeArticleId: navState.activeArticleId ?? props.activeArticleId,
        }
      : props;

  return (
    <FullLayoutLeftSidebar
      ref={ctx.sideNavRef as React.Ref<HTMLDivElement>}
      open={ctx.isSideNavOpen}
      widthPx={ctx.leftNavWidth}
      onResizeStart={ctx.handleResizeStart}
      onResizeKeyDown={ctx.handleResizeKeyDown}
      ariaValuenow={ctx.ariaValuenow}
      ariaValuemin={ctx.ariaValuemin}
      ariaValuemax={ctx.ariaValuemax}
      sidebarProps={sidebarProps}
    />
  );
}
LeftSidebar.displayName = 'FullLayout.LeftSidebar';
